import { Link, Box, Button, Grid, Stack, SvgIcon, useTheme, useMediaQuery, Skeleton, CircularProgress } from '@mui/material';
import { useContext } from 'react';
import { Save01, Edit05, Plus, Download01 } from '../../../assets';
import { PurchaseOrderDetailsContext, PurchaseOrderDetailsValues } from '../contexts/PurchaseOrderDetailsContext';
import { useTranslation } from 'react-i18next';
import PageTitle from '../../../components/shared/PageTitle';
import LeavePageModal from '../../../components/shared/dialogs/LeavePageModal';
import CustomBreadCrumbs from '../../../components/ui/CustomBreadCrumbs';
import { Link as RouterLink } from 'react-router-dom';

const PurchaseOrdersDetailsTop = () => {
  const { saveClicked,
    addItemClicked,
    isReceiving,
    isLoading,
    showAdjustButton,
    isProcessing,
    adjustClicked,
    downloadClicked,
    showSave,
    cannotOverReceive,
    isDownloading,
    canStoreAddItemsToPO,
    showAutosaveMessage,
    handleLeavePageModalConfirm,
    handleLeavePageModalClose,
    handleLeavePageModalCancel,
    blocker,
    modifiedPOLines,
    ewsOrderNumber,
    showOverReceivingWarningModal } = useContext(PurchaseOrderDetailsContext) as PurchaseOrderDetailsValues;

  const theme = useTheme();
  const { t } = useTranslation('purchaseOrderDetails');
  const isMobile = useMediaQuery(`(max-width:${theme.breakpoints.values.md}px)`);

  return <Grid item
    xs={12}>
    <Box>
      <CustomBreadCrumbs title={ewsOrderNumber?.toString() || ''}>
        <Link to="/store/goods-receipts"
          component={RouterLink}>{t('title')}</Link>
      </CustomBreadCrumbs>
    </Box>

    <Stack width='100%'
      spacing={2}
      direction={isMobile ? 'column' : 'row'}
      sx={{
        justifyContent: 'space-between',
      }}>
      <Box width={isMobile ? '100%' : 'auto'}>
        <PageTitle>
          {t('title')}
        </PageTitle>
      </Box>
      <Box width={isMobile ? '100%' : 'auto'}
        sx={{
          display: 'flex',
          justifyContent: { xs: 'flex-start', md: 'flex-end' },
        }}>
        {isLoading ? <Skeleton variant='rectangular'
          sx={{ borderRadius: '12px' }}
          height={40}
          width={120} /> :
          <Stack spacing={5}
            direction='row'>
            <Button variant="secondary"
              size="lg"
              sx={{ verticalAlign: 'bottom' }}
              onClick={downloadClicked}
              disabled={isProcessing}
              startIcon={isDownloading ? <CircularProgress size={20}
                sx={{ ml: '-4px', mr: '4px' }} /> : <SvgIcon><Download01 /></SvgIcon>}>
              {t('download')}
            </Button>
            {showSave && canStoreAddItemsToPO &&
              <Button variant="primary"
                size="lg"
                sx={{ verticalAlign: 'bottom' }}
                onClick={addItemClicked}
                disabled={isProcessing}
                startIcon={<SvgIcon> <Plus /> </SvgIcon>}>
                {t('addItem')}
              </Button>
            }
            {showSave &&
              <Button variant="primary"
                size="lg"
                sx={{ verticalAlign: 'bottom', ml: '8px' }}
                onClick={saveClicked}
                disabled={isProcessing || cannotOverReceive}
                startIcon={<SvgIcon> <Save01 /> </SvgIcon>}>
                {t('save')}
              </Button>}
            {showAdjustButton &&
            <Button variant="primary"
              size="lg"
              sx={{ verticalAlign: 'bottom', ml: '8px' }}
              onClick={adjustClicked}
              disabled={isProcessing}
              startIcon={<SvgIcon> <Edit05 /> </SvgIcon>}>
              {t('adjustBtn')}
            </Button>
            }
          </Stack>}
      </Box>
    </Stack >

    <LeavePageModal
      open={(blocker.state === 'blocked' && modifiedPOLines && modifiedPOLines.size > 0) ?? false}
      onConfirm={handleLeavePageModalConfirm}
      onClose={handleLeavePageModalClose}
      onCancel={handleLeavePageModalCancel}
      onConfirmUrl='/store/daily-waste-checksheet'
      leaveWarningContent={t('saveOnLeaveWarningContent')}
      leaveWarningTitle={t('saveOnLeaveWarningTitle')} />
  </Grid>;

};

export default PurchaseOrdersDetailsTop;